import { render, staticRenderFns } from "./ProductRecords.vue?vue&type=template&id=17094e7a&"
import script from "./ProductRecords.vue?vue&type=script&lang=js&"
export * from "./ProductRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports